<template>
    <b-card>
        <b-row class="py-4 justify-content-md-center">
            <b-col align-self="end" cols="12" md="auto" class="text-center">
                <div class="font-weight-bold mb-2">{{name}}</div>
                <div class="mx-5">
                    <b-img class="box" :src="imgSrc" />
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>
.class1 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.box {
    width: 100%;
    height: 250px;
    object-fit: cover;
}
</style>

<script>
export default {
    props: {
        name: {
            type: String
        },
        imgSrc: {
            type: String
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>